import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
};

export type Query = {
  __typename?: 'Query';
  activity: Array<Activity>;
  hello: Scalars['String'];
  parks: Array<Park>;
  park: Park;
};


export type QueryParksArgs = {
  filter?: Maybe<ParkFilter>;
  input: ParkInput;
};


export type QueryParkArgs = {
  parkCode: Scalars['String'];
};

export type Activity = {
  __typename?: 'Activity';
  id: Scalars['String'];
  name: Scalars['String'];
};

export type Park = {
  __typename?: 'Park';
  id: Scalars['String'];
  parkCode: Scalars['String'];
  states: Scalars['String'];
  weatherInfo: Scalars['String'];
  directionsInfo: Scalars['String'];
  addresses: Array<Address>;
  entranceFees: Array<EntranceFee>;
  topics: Array<IdName>;
  name: Scalars['String'];
  latitude: Scalars['String'];
  activities: Array<Activity>;
  operatingHour: Array<OperatingHour>;
  url: Scalars['String'];
  longitude: Scalars['String'];
  contacts: Array<Contact>;
  entrancePasses: Array<EntrancePass>;
  designation: Scalars['String'];
  images: Array<Image>;
  fullName: Scalars['String'];
  latLong: Scalars['String'];
  directionsUrl: Scalars['String'];
  description: Scalars['String'];
};

export type Address = {
  __typename?: 'Address';
  postalCode: Scalars['String'];
  city: Scalars['String'];
  stateCode: Scalars['String'];
  line1: Scalars['String'];
  type: Scalars['String'];
  line3: Scalars['String'];
  line2: Scalars['String'];
};

export type EntranceFee = {
  __typename?: 'EntranceFee';
  cost: Scalars['String'];
  description: Scalars['String'];
  title: Scalars['String'];
};

export type IdName = {
  __typename?: 'IDName';
  id: Scalars['String'];
  name: Scalars['String'];
};

export type OperatingHour = {
  __typename?: 'OperatingHour';
  name: Scalars['String'];
  description: Scalars['String'];
  standardHour: Hour;
  exceptions: Array<OperatingHourException>;
};

export type Hour = {
  __typename?: 'Hour';
  sunday: Scalars['String'];
  monday: Scalars['String'];
  tuesday: Scalars['String'];
  wednesday: Scalars['String'];
  thursday: Scalars['String'];
  friday: Scalars['String'];
  saturday: Scalars['String'];
};

export type OperatingHourException = {
  __typename?: 'OperatingHourException';
  name: Scalars['String'];
  startDate: Scalars['String'];
  endDate: Scalars['String'];
};

export type Contact = {
  __typename?: 'Contact';
  phoneNumbers: Array<PhoneNumber>;
  emailAddresses: Array<EmailAddress>;
};

export type PhoneNumber = {
  __typename?: 'PhoneNumber';
  phoneNumber: Scalars['String'];
  description: Scalars['String'];
  extension: Scalars['String'];
  type: Scalars['String'];
};

export type EmailAddress = {
  __typename?: 'EmailAddress';
  emailAddress: Scalars['String'];
  description: Scalars['String'];
};

export type EntrancePass = {
  __typename?: 'EntrancePass';
  cost: Scalars['String'];
  description: Scalars['String'];
  title: Scalars['String'];
};

export type Image = {
  __typename?: 'Image';
  credit: Scalars['String'];
  altText: Scalars['String'];
  title: Scalars['String'];
  caption: Scalars['String'];
  url: Scalars['String'];
};

export type ParkFilter = {
  designation?: Maybe<Filter>;
  directionsInfo?: Maybe<Filter>;
  states?: Maybe<Filter>;
  parkCode?: Maybe<Filter>;
};

export type Filter = {
  eq?: Maybe<Scalars['String']>;
  neq?: Maybe<Scalars['String']>;
  lt?: Maybe<Scalars['Float']>;
  gt?: Maybe<Scalars['Float']>;
  in?: Maybe<Array<Scalars['String']>>;
  regex?: Maybe<Scalars['String']>;
};

export type ParkInput = {
  limit: Scalars['Float'];
  start: Scalars['Float'];
};

export type ParksQueryVariables = Exact<{
  input: ParkInput;
  filter: ParkFilter;
}>;


export type ParksQuery = (
  { __typename?: 'Query' }
  & { parks: Array<(
    { __typename?: 'Park' }
    & Pick<Park, 'parkCode' | 'name' | 'fullName' | 'states' | 'weatherInfo' | 'directionsInfo'>
    & { images: Array<(
      { __typename?: 'Image' }
      & Pick<Image, 'credit' | 'url'>
    )> }
  )> }
);

export type ParkDetailQueryVariables = Exact<{
  parkCode: Scalars['String'];
}>;


export type ParkDetailQuery = (
  { __typename?: 'Query' }
  & { park: (
    { __typename?: 'Park' }
    & Pick<Park, 'name' | 'fullName' | 'states' | 'description' | 'weatherInfo'>
    & { images: Array<(
      { __typename?: 'Image' }
      & Pick<Image, 'credit' | 'url' | 'altText' | 'caption'>
    )>, addresses: Array<(
      { __typename?: 'Address' }
      & Pick<Address, 'line1' | 'line2' | 'city' | 'stateCode' | 'postalCode'>
    )> }
  ) }
);


export const ParksDocument = gql`
    query Parks($input: ParkInput!, $filter: ParkFilter!) {
  parks(input: $input, filter: $filter) {
    parkCode
    name
    fullName
    states
    weatherInfo
    directionsInfo
    images {
      credit
      url
    }
  }
}
    `;

/**
 * __useParksQuery__
 *
 * To run a query within a React component, call `useParksQuery` and pass it any options that fit your needs.
 * When your component renders, `useParksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useParksQuery({
 *   variables: {
 *      input: // value for 'input'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useParksQuery(baseOptions?: Apollo.QueryHookOptions<ParksQuery, ParksQueryVariables>) {
        return Apollo.useQuery<ParksQuery, ParksQueryVariables>(ParksDocument, baseOptions);
      }
export function useParksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ParksQuery, ParksQueryVariables>) {
          return Apollo.useLazyQuery<ParksQuery, ParksQueryVariables>(ParksDocument, baseOptions);
        }
export type ParksQueryHookResult = ReturnType<typeof useParksQuery>;
export type ParksLazyQueryHookResult = ReturnType<typeof useParksLazyQuery>;
export type ParksQueryResult = Apollo.QueryResult<ParksQuery, ParksQueryVariables>;
export const ParkDetailDocument = gql`
    query ParkDetail($parkCode: String!) {
  park(parkCode: $parkCode) {
    name
    fullName
    states
    description
    weatherInfo
    images {
      credit
      url
      altText
      caption
    }
    addresses {
      line1
      line2
      city
      stateCode
      postalCode
    }
  }
}
    `;

/**
 * __useParkDetailQuery__
 *
 * To run a query within a React component, call `useParkDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useParkDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useParkDetailQuery({
 *   variables: {
 *      parkCode: // value for 'parkCode'
 *   },
 * });
 */
export function useParkDetailQuery(baseOptions?: Apollo.QueryHookOptions<ParkDetailQuery, ParkDetailQueryVariables>) {
        return Apollo.useQuery<ParkDetailQuery, ParkDetailQueryVariables>(ParkDetailDocument, baseOptions);
      }
export function useParkDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ParkDetailQuery, ParkDetailQueryVariables>) {
          return Apollo.useLazyQuery<ParkDetailQuery, ParkDetailQueryVariables>(ParkDetailDocument, baseOptions);
        }
export type ParkDetailQueryHookResult = ReturnType<typeof useParkDetailQuery>;
export type ParkDetailLazyQueryHookResult = ReturnType<typeof useParkDetailLazyQuery>;
export type ParkDetailQueryResult = Apollo.QueryResult<ParkDetailQuery, ParkDetailQueryVariables>;